<template>
    <v-card width="100%">
        <v-card-title class="pt-0 pb-2 justify-center"><h2>Vector stores overview</h2></v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            Vertor Stores are updated automatically when files are uploaded through ares.
        </v-card-text>
        <v-divider></v-divider>
        <v-card-text>
            Number of stores: {{ stores.length }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-btn color="primary" small :disabled="disableAll!==0" @click="refreshAll">Refresh Stores</v-btn>
            <!-- <v-btn color="primary" small :disabled="disableAll!==0&&stores.length>0" @click="refreshFiles">Refresh Store Files</v-btn> -->
            <v-spacer></v-spacer>
            <v-btn color="primary" small :disabled="disableAll!==0" @click="updateTerms">Update Tems & Cond.</v-btn>
            <v-btn color="primary" small :disabled="disableAll!==0" @click="createAll">Create stores</v-btn>
            <v-btn color="error" small :disabled="disableAll!==0" @click="deleteAll">Delete Stores</v-btn>
        </v-card-actions>
        <showProgress ref="showProgress"/>
    </v-card>
</template>

<script>
    import showProgress from "@/components/showProgress.vue";

    export default {
        components: {
            showProgress,
        },
        props: {
            stores: {
                required: true,
            }
        },
        data() {
            return {
                disableAll: 0,
            }
        },
        methods: {
            createAll() {
                this.disableAll += 1;
                this.$axios.post("ares/json/ares/syst/openai/createVectorStores.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "createVectorStores",
                    },
                    createVectorStores: {},
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                        this.disableAll -= 1;
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.createVectorStores.text,
                            color: res.data.createVectorStores.color,
                        });
                        this.disableAll -= 1;
                        this.$emit("updateData", "refresh");
                    }
                });
            },                
            // refreshFiles() {
            //     this.disableAll += 1;
            //     this.$refs.showProgress.open();
            //     this.$axios.post("ares/json/ares/syst/openai/createVectorStoreFiles.p", {
            //         header: {
            //             token: this.$session.get("ARES"),
            //             clientSessionId: this.$session.id(),
            //             request: "createVectorStoreFiles",
            //         },
            //         createVectorStoreFiles: {},
            //     }).then((res) => {
            //         if (res.data.error) {
            //             // console.log(res.data.error);
            //             this.$store.dispatch("setSnackbar", {
            //                 showing: true,
            //                 text: res.data.error.message,
            //                 color: "error",
            //             });
            //             this.disableAll -= 1;
            //             this.$refs.showProgress.close();
            //         } else {
            //             this.$store.dispatch("setSnackbar", {
            //                 showing: true,
            //                 text: res.data.createVectorStoreFiles.text,
            //                 color: res.data.createVectorStoreFiles.color,
            //             });
            //             this.disableAll -= 1;
            //             this.$refs.showProgress.close();
            //             this.$emit("updateData", "refresh");
            //         }
            //     });
            // },                
            refreshAll() {
                this.$emit("updateData", "refresh");
            },
            updateTerms() {
                this.disableAll += 1;
                this.$axios.post("ares/json/ares/syst/openai/updateTermsConditions.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "updateTermsConditions",
                    },
                    updateTermsConditions: {},
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                        this.disableAll -= 1;
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.updateTermsConditions.text,
                            color: res.data.updateTermsConditions.color,
                        });
                        this.disableAll -= 1;
                        this.$emit("updateData", "refresh");
                    }
                });
            },
            deleteAll() {
                this.disableAll += 1;
                this.$axios.post("ares/json/ares/syst/openai/deleteVectorStores.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "deleteVectorStores",
                    },
                    deleteVectorStores: this.stores,
                }).then((res) => {
                    if (res.data.error) {
                        // console.log(res.data.error);
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.error.message,
                            color: "error",
                        });
                        this.disableAll -= 1;
                    } else {
                        this.$store.dispatch("setSnackbar", {
                            showing: true,
                            text: res.data.deleteVectorStores.text,
                            color: res.data.deleteVectorStores.color,
                        });
                        this.disableAll -= 1;
                        this.$emit("updateData", "refresh");
                    }
                });
            },
        }
    }
</script>
